import { render } from "./quiz-v1-multiple-select.vue?vue&type=template&id=21cf89f9&scoped=true"
import script from "./quiz-v1-multiple-select.vue?vue&type=script&lang=js"
export * from "./quiz-v1-multiple-select.vue?vue&type=script&lang=js"

import "./quiz-v1-multiple-select.vue?vue&type=style&index=0&id=21cf89f9&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cf89f9"]])

export default __exports__